module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audio-wrap clearFloat"
  }, _vm._l((_vm.results.data), function(audio, index) {
    return _c('div', {
      staticClass: "singleAudioBox clearFloat",
      attrs: {
        "data-id": audio.audioID
      }
    }, [_c('span', {
      staticClass: "audioTitleInfo clearFloat",
      on: {
        "click": function($event) {
          _vm.openPage(audio.webUrl)
        }
      }
    }, [_c('span', {
      staticClass: "audioTitle"
    }, [_vm._v("【"), _c('b', {
      domProps: {
        "innerHTML": _vm._s(audio.webTitleFormat)
      }
    }), _vm._v("】")]), _vm._v(" "), _c('span', {
      staticClass: "audioSubTitle"
    }, [_vm._v(" " + _vm._s(audio.singer))])]), _vm._v(" "), _c('span', {
      staticClass: "audioUrl",
      on: {
        "click": function($event) {
          _vm.openPage(audio.webUrl)
        }
      }
    }, [_vm._v(_vm._s(audio.webUrl))]), _vm._v(" "), (!audio.hasAction) ? _c('a', {
      staticClass: "audioIsSave saveBtn"
    }, [_vm._v(_vm._s(audio.statusDesc))]) : _vm._e(), _vm._v(" "), (audio.hasAction) ? _c('a', {
      staticClass: "audioNotSave saveBtn",
      on: {
        "click": function($event) {
          _vm.saveEvidence(index)
        }
      }
    }, [_vm._v("存证")]) : _vm._e()])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a0756994"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/results/AudioResults.vue
// module id = 778
// module chunks = 1